module.exports = __webpack_public_path__ + "assets/img/mecha1-a3c1a1c6.jpg";